import React, { useState, useEffect } from "react";
import axios from "axios";
import { FB_URL } from '../store/actions/types'
import {
  isMobile,
  isBrowser
} from 'react-device-detect'

const CryptoPriceColumn = () => {
  const [prices, setPrices] = useState({
    bitcoin: null,
    ethereum: null,
    bnb: null,        // ← changed from dogecoin
    mevision: null,
  });

  const fetchMEV = async () => {
     const blank = "";
     const res = await axios.post(`${FB_URL}/m110-getmevprice`, {
      aaa: blank,
      bbb: blank,
      ccc: blank,
    });
    
    const MEVprice = Number(res.data.MEVprice);
    return MEVprice;
  }

  const fetchCryptoPrices = async () => {
    try {
      // Updated CoinGecko ids: bitcoin,ethereum,binancecoin
      var MEVprice;
      MEVprice = 0;
      console.log('fetchCryptoPrices 1: ');
      const response = await axios.get(
        "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,binancecoin&vs_currencies=usd"
      );
     console.log('fetchCryptoPrices 2: ');
      MEVprice = await fetchMEV();
     console.log('fetchCryptoPrices 3: ');

      setPrices({
        bitcoin: response.data.bitcoin.usd,
        ethereum: response.data.ethereum.usd,
        bnb: response.data.binancecoin.usd,   // ← now BNB
        mevision: MEVprice
      });
    } catch (error) {
      console.log('fetchCryptoPrices err: ', error);
       if (MEVprice!=0) {
       //nothing
       }
       else {
          MEVprice = await fetchMEV();
          setPrices({
            mevision: MEVprice
          });
       }
      // error handling unchanged
    }
  };

// const fetchCryptoPrices = async () => {
//   try {
//     console.log('fetchCryptoPrices 1:');

//     let response;

//     try {
//       // Primary: CoinGecko
//       response = await axios.get(
//         "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,binancecoin&vs_currencies=usd",
//         { timeout: 10000 }
//       );

//       console.log('CoinGecko OK');

//     } catch (coinGeckoError) {

//       console.log('CoinGecko failed, trying fallback:', coinGeckoError);

//       // FALLBACK GOES HERE
//       response = await axios.get(
//         "FALLBACK_URL_HERE",
//         { timeout: 10000 }
//       );

//       console.log('Fallback API OK');
//     }

//     console.log('fetchCryptoPrices 2:');

//     const MEVprice = await fetchMEV();

//     console.log('fetchCryptoPrices 3:');

//     setPrices({
//       bitcoin: response.data.bitcoin.usd,
//       ethereum: response.data.ethereum.usd,
//       bnb: response.data.binancecoin.usd,
//       mevision: MEVprice
//     });

//   } catch (error) {
//     console.log('fetchCryptoPrices err: ', error);
//   }
// };

  useEffect(() => {
    fetchCryptoPrices(); // Fetch prices on component mount
    const interval = setInterval(fetchCryptoPrices, 60000); // Update every minute
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <div>
      {isMobile ? 
        <div style={{ textAlign: "center", padding: "0px" }}>
          <div style={{ margin: "10px 0", fontSize: "12px", color: "#FFFFFF" }}>
            <b>BTC:</b> &nbsp;${prices.bitcoin ? prices.bitcoin.toFixed(2) : "Loading..."}
            <b>&nbsp;ETH:</b> &nbsp;${prices.ethereum ? prices.ethereum.toFixed(2) : "Loading..."}
            <b>&nbsp;BNB:</b> &nbsp;${prices.bnb ? prices.bnb.toFixed(2) : "Loading..."}
            <b>&nbsp;MEV:</b> &nbsp;${prices.mevision ? prices.mevision.toFixed(5) : "Loading..."}
          </div>
        </div>
        : 
        <div style={{ textAlign: "center", padding: "0px" }}>
          <div style={{ margin: "10px 0", fontSize: "14px", color: "#1025a2" }}>
            <b>BTC:</b> &nbsp;${prices.bitcoin ? prices.bitcoin.toFixed(2) : "Loading..."}
            <b>&nbsp;ETH:</b> &nbsp;${prices.ethereum ? prices.ethereum.toFixed(2) : "Loading..."}
            <b>&nbsp;BNB:</b> &nbsp;${prices.bnb ? prices.bnb.toFixed(2) : "Loading..."}
            <b>&nbsp;MEV:</b> &nbsp;${prices.mevision ? prices.mevision.toFixed(5) : "Loading..."}
          </div>
        </div>
      }
    </div>
  );
};

export default CryptoPriceColumn;
////////////////////////////////////////////////////////////////////////////////
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FB_URL } from '../store/actions/types'
// import {
//   isMobile,
//   isBrowser
// } from 'react-device-detect'

// const CryptoPriceColumn = () => {
//   const [prices, setPrices] = useState({
//     bitcoin: null,
//     ethereum: null,
//     dogecoin: null,
//     mev: null,
//   });

//   const fetchMEV = async () => {
//      const blank = "";
//      const res = await axios.post(`${FB_URL}/m110-getmevprice`, {
//       aaa: blank,
//       bbb: blank,
//       ccc: blank,
//     });
    
//     const MEVprice = Number(res.data.MEVprice);
    

//     return MEVprice;
//   }

//   const fetchCryptoPrices = async () => {
//     try {
//       const response = await axios.get(
//         "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,dogecoin&vs_currencies=usd"
//       );
  
//       const MEVprice = await fetchMEV()

//       setPrices({
//         bitcoin: response.data.bitcoin.usd,
//         ethereum: response.data.ethereum.usd,
//         dogecoin: response.data.dogecoin.usd,
//         mevision: MEVprice
//       });
//     } catch (error) {
      
//     }
//   };

//   useEffect(() => {
//     fetchCryptoPrices(); // Fetch prices on component mount
//     const interval = setInterval(fetchCryptoPrices, 60000); // Update prices every minute
//     return () => clearInterval(interval); // Cleanup interval on unmount
//   }, []);

//   return (
//     <div>
//    {isMobile ? 
//     <div style={{ textAlign: "center", padding: "0px" }}>
//     <div style={{ margin: "10px 0", fontSize: "12px", color: "#FFFFFF" }}>
//       <b>BTC:</b> &nbsp;${prices.bitcoin ? prices.bitcoin.toFixed(2) : "Loading..."}
//       <b>&nbsp;ETH:</b> &nbsp;${prices.ethereum ? prices.ethereum.toFixed(2) : "Loading..."}
//       <b>&nbsp;DOGE:</b> &nbsp;${prices.dogecoin ? prices.dogecoin.toFixed(2) : "Loading..."}
//       <b>&nbsp;MEV:</b> &nbsp;${prices.mevision ? prices.mevision.toFixed(5) : "Loading..."}
//     </div>
//   </div>
//     : 
//     <div style={{ textAlign: "center", padding: "0px" }}>
//     <div style={{ margin: "10px 0", fontSize: "14px", color: "#1025a2" }}>
//       <b>BTC:</b> &nbsp;${prices.bitcoin ? prices.bitcoin.toFixed(2) : "Loading..."}
//       <b>&nbsp;ETH:</b> &nbsp;${prices.ethereum ? prices.ethereum.toFixed(2) : "Loading..."}
//       <b>&nbsp;DOGE:</b> &nbsp;${prices.dogecoin ? prices.dogecoin.toFixed(2) : "Loading..."}
//       <b>&nbsp;MEV:</b> &nbsp;${prices.mevision ? prices.mevision.toFixed(5) : "Loading..."}
//     </div>
//   </div>
//    }
//    </div>
//   );
// };

// export default CryptoPriceColumn;
//////////////////////////////////////////////////////////////////////////////////////////